import * as dayjs from "dayjs";
import i18n from '@/plugins/i18n';
import { is_set_overlapse } from "@/helper/dateTime";
import Vue from 'vue'

//===========================================================

export function parseDate_Time(item) {
  const teach_days = teach_day_parser(item);
  const midterm_start_date_time =
    item.mexam_date && item.mexam_date !== "0000-00-00"
      ? dayjs(item.mexam_date + " " + item.mexam_time)
      : null;
  const midterm_end_date_time =
    item.mexam_date && item.mexam_date !== "0000-00-00"
      ? dayjs(item.mexam_date + " " + item.mexam_time2)
      : null;
  const final_start_date_time =
    item.exam_date && item.exam_date !== "0000-00-00"
      ? dayjs(item.exam_date + " " + item.exam_time)
      : null;
  const final_end_date_time =
    item.exam_date && item.exam_date !== "0000-00-00"
      ? dayjs(item.exam_date + " " + item.exam_time2)
      : null;
  return {
    ...item,
    time_slot: item.time_slot ? item.time_slot : [],
    teach_days,
    midterm_start_date_time,
    midterm_end_date_time,
    midterm: {
      start_date_time: midterm_start_date_time,
      end_date_time: midterm_end_date_time,
    },
    final_start_date_time,
    final_end_date_time,
    final: {
      start_date_time: final_start_date_time,
      end_date_time: final_end_date_time,
    },
  };
}

//===========================================================
// แปลงข้อมูลวันที่เรียนให้เป็น object
export function teach_day_parser(teach_table_data) {
  let all_teach_day = '';
  if (teach_table_data.teach_day !== "0") {
    all_teach_day +=
      teach_table_data.teach_day +
      "x" +
      teach_table_data.teach_time +
      "-" +
      teach_table_data.teach_time2;
  }
  if (teach_table_data.teachtime_str) all_teach_day += "," + teach_table_data.teachtime_str;
  all_teach_day = all_teach_day
    .split(",")
    .filter((item) => item.length > 0);
  return all_teach_day.map((item) => {
    const info = item.split("x");
    const times = info[1].split("-");
    const day = info[0];
    const time = times[0].length === 8 ? times[0] : times[0] + ":00";
    const time2 = times[1].length === 8 ? times[1] : times[1] + ":00";

    // dayjs_sample_start และ dayjs_sample_end เอาไว้ใช้แสดงโดยไม่ใช้วันที่เท่านั้น เพราะวันที่จะไม่ถูก ต้องดูจาก timeslot ซึ่งจะไม่แสดงตรงนี้
    const dayjs_sample_start = dayjs()
      .day(parseInt(day) - 1)
      .hour(time.substring(0, 2))
      .minute(time.substring(3, 5))
      .second(time.substring(6, 8));
    const dayjs_sample_end = dayjs()
      .day(parseInt(day) - 1)
      .hour(time2.substring(0, 2))
      .minute(time2.substring(3, 5))
      .second(time2.substring(6, 8));
    return { day, time, time2, dayjs_sample_start, dayjs_sample_end };
  });
}

//===========================================================
export function computed_subject_list(subject_list) {
  const temp = subject_list.map((item) => {
    const same_subject = subject_list.filter(
      (item_2) => item_2.subject_id === item.subject_id
    );
    const same_section = subject_list.filter(
      (item_2) => item_2.section === item.section && item_2.subject_id === item.subject_id
    );

    return {
      ...item,
      has_pair: (same_subject.length > 1) ? true : false,
      has_same_section: (same_section.length > 1) ? true : false
    };

  });
  return temp
    .map((item) => parseDate_Time(item))
    .sort((a, b) => {
      if (a.subject_id > b.subject_id) return 1;
      if (a.subject_id < b.subject_id) return -1;
      if (a.subject_id == b.subject_id) {
        if (a.lect_or_prac === "ป") return 1;
        return -1;
      }
      return 0;
    });
}

//===========================================================

export function compare_exam_date_time(teach_table_object, registering_subject_list) {
  const temp_data = [...registering_subject_list, teach_table_object];
  const temp_data_midterm = temp_data.filter(
    (item) => item.midterm.start_date_time !== null
  );
  const temp_data_final = temp_data.filter(
    (item) => item.final.start_date_time !== null
  );
  const result_midterm = is_set_overlapse(
    temp_data_midterm.map((item) => {
      return {...item.midterm, subject_id: item.subject_id};
    })
  );
  const result_final = is_set_overlapse(
    temp_data_final.map((item) => {
      return {...item.final, subject_id: item.subject_id};
    })
  );
  return !result_midterm && !result_final;
}

//===========================================================

export function compare_timeslot(teach_table_object, registering_subject_list) {
  const temp_data = [...registering_subject_list, teach_table_object];
  let all_time_slot = [];
  temp_data.map((item) => {
    const temp_time_slot = item.time_slot.map(item_time_slot => ({...item_time_slot, subject_id: item.subject_id}));
    all_time_slot = [...all_time_slot, ...temp_time_slot];
  });
  all_time_slot = all_time_slot.map((item) => ({
    start_date_time: dayjs(item.START_DATE_TIME, "YYYY-MM-DD HH:mm:ss"),
    end_date_time: dayjs(item.END_DATE_TIME, "YYYY-MM-DD HH:mm:ss"),
    subject_id: item.subject_id,
  }));
  const result = is_set_overlapse(all_time_slot);
  return !result;
}

//===========================================================

export async function check_integrity_time(
  adding_subject_id,
  registering_subject_list,
  primary_teach_table_object,
  secondary_teach_table_object = null
) {
  const result_exam = primary_teach_table_object.skip_date_time
    ? true
    : await compare_exam_date_time(primary_teach_table_object, registering_subject_list);
  if (!result_exam) {
    Vue.toasted.error(
      i18n.t("pre_regis_add_subject.error_in_taking_this_course") +
      adding_subject_id +
      ": " +
      i18n.t("pre_regis_add_subject.exam_collide"),
      { duration: 0 }
    );
  }
  const result_time_slot = await compare_timeslot(
    primary_teach_table_object, registering_subject_list
  );
  if (!result_time_slot) {
    Vue.toasted.error(
      i18n.t("pre_regis_add_subject.error_in_taking_this_course") +
      adding_subject_id +
      ": " +
      i18n.t("pre_regis_add_subject.time_slot_collide"),
      { duration: 0 }
    );
  }
  let result_secondary = true;
  if (
    secondary_teach_table_object &&
    !secondary_teach_table_object.skip_date_time
  ) {
    const result_secondary_exam = await compare_exam_date_time(
      secondary_teach_table_object, registering_subject_list
    );
    if (!result_secondary_exam) {
      Vue.toasted.error(
        i18n.t("pre_regis_add_subject.error_in_taking_this_course") +
        adding_subject_id +
        ": " +
        i18n.t("pre_regis_add_subject.prac_exam_collide"),
        { duration: 0 }
      );
    }
    const result_secondary_time_slot = await compare_timeslot(
      secondary_teach_table_object, registering_subject_list
    );
    if (!result_secondary_time_slot) {
      Vue.toasted.error(
        i18n.t("pre_regis_add_subject.error_in_taking_this_course") +
        adding_subject_id +
        ": " +
        i18n.t("pre_regis_add_subject.prac_time_slot_collide"),
        { duration: 0 }
      );
    }
    result_secondary = result_secondary_exam && result_secondary_time_slot;
  }
  return result_exam && result_time_slot && result_secondary;
}